<template>
  <div class="main">
    <div class="top">
      <span class="help" @click="toHelp">帮助</span>
    </div>
    <!-- 用户信息 -->
    <!-- @click="toUser" -->
    <div class="user">
      <img :src="head_pic" class="img" @error="defaultPro()" alt />
      <div class="content">
        <div class="item">
          <div class="title">
            <span>可用积分</span>
            <!-- <img class="arrow" src="../../assets/integral/arrow.png" alt /> -->
          </div>
          <span class="num">{{ totalCredit }}</span>
        </div>
        <div class="item">
          <div class="title">
            <span>今日玩赚</span>
            <!-- <img class="arrow" src="../../assets/integral/arrow.png" alt /> -->
          </div>
          <span class="num">{{ todayCredit }}</span>
        </div>
      </div>
    </div>
    <!-- 广告位 -->
    <div class="ad" v-if="adShow">
      <swiper v-if="adList.length >= 2" :options="adSwiperOption">
        <swiper-slide
          v-for="(item, index) of adList"
          :key="'ad-' + index"
          :data-route="item.route_url"
        >
          <img :src="item.images" alt class="img" />
        </swiper-slide>
      </swiper>
      <div v-else @click="toAd(adList[0].route_url)">
        <img :src="adList[0].images" alt class="img" />
      </div>
    </div>
    <!-- 玩游戏赚积分 -->
    <div class="module" v-if="CreditsList.length">
      <div class="title">
        <img src="../../assets/integral/ring.png" class="icon" />
        <div class="text">
          <span>玩游戏赚积分</span>
        </div>
      </div>
      <div class="content game">
        <div class="one" v-if="CreditsList.length == 1">
          <img
            :src="item.game_logo"
            class="img"
            @click="toGame(item.game_id, item.game_api_url)"
            v-for="(item, index) in CreditsList"
            :key="index"
          />
        </div>
        <div class="two" v-if="CreditsList.length == 2">
          <div v-for="(item, index) in CreditsList" :key="index">
            <img
              :src="item.game_logo"
              class="img"
              @click="toGame(item.game_id, item.game_api_url)"
            />
          </div>
          <!-- <div>
            <img src="../../assets/integral/sz-two.png" class="img" @click="toGame(1)"/>
          </div>-->
        </div>
        <div class="three" v-if="CreditsList.length == 3">
          <div v-for="(item, index) in CreditsList" :key="index">
            <img
              :src="item.game_logo"
              class="img"
              @click="toGame(item.game_id, item.game_api_url)"
            />
          </div>
          <!-- <div>
            <img src="../../assets/integral/sz-more.png" class="img" @click="toGame(1)" />
          </div>
          <div>
            <img src="../../assets/integral/cq-more.png" class="img" @click="toGame(1)" />
          </div>-->
        </div>
        <div v-if="CreditsList.length > 3">
          <swiper :options="gameSwiperOption" ref="mySwiper">
            <swiper-slide
              data-type="1"
              v-for="(item, index) in CreditsList"
              :key="index"
              :data-id="item.game_id"
            >
              <img :src="item.game_logo" class="img" />
            </swiper-slide>
            <!-- <swiper-slide data-type="2">
              <img src="../../assets/integral/ddz-more.png" class="img" />
            </swiper-slide>
            <swiper-slide data-type="3">
              <img src="../../assets/integral/sz-more.png" class="img" />
            </swiper-slide>
            <swiper-slide data-type="4">
              <img src="../../assets/integral/ddz-more.png" class="img" />
            </swiper-slide>-->
          </swiper>
        </div>
      </div>
    </div>
    <!-- 每日任务 -->
    <div class="module">
      <div class="title">
        <img src="../../assets/integral/ring.png" class="icon" />
        <div class="text">
          <span>每日任务</span>
        </div>
      </div>
      <div class="content task">
        <div
          class="item"
          v-for="(item, index) of taskList"
          :key="'task-' + index"
        >
          <div class="photo">
            <img :src="item.icon" />
          </div>
          <div class="text">
            <p>{{ item.name }}</p>
            <p>{{ item.intro }}</p>
          </div>
          <div
            class="btn"
            :class="{ used: item.task_type == 1 && item.rewarded }"
            @click="toTask(item.url.url, item.task_type == 1)"
          >
            {{
              item.task_type == 1 && item.rewarded ? "已完成" : item.button_name
            }}
          </div>
        </div>
        <!-- 充值类游戏 -->
        <div class="item" v-if="userID != '1809228' && userID != '1873418'">
          <div class="photo">
            <img src="./../../assets/integral/game.png" />
          </div>
          <div class="text">
            <p>
              小游戏<img
                src="./../../assets/integral/redPacket.png"
                class="gameimg"
              />
            </p>
            <p>免费玩游戏，充值赠积分</p>
          </div>
          <div class="btn" @click="toRechargeGame(rechargeData.supplier_id)">
            开玩
          </div>
        </div>
        <!-- 激励视频 -->
        <div
          class="item"
          v-if="
            advertising.advertising_name &&
            userID != '1809228' &&
            userID != '1873418'
          "
        >
          <div class="photo">
            <img :src="advertising.icon" />
          </div>
          <div class="text">
            <p>
              {{ advertising.advertising_name
              }}<img src="./../../assets/integral/hot.png" />
            </p>
            <p>边看广告边赚钱</p>
          </div>
          <div
            class="btn"
            v-if="advertisingisIntegral == 0 && advertising.is_vindicate == 1"
          >
            <van-button
              @click="toAdvertising(advertising.id)"
              :disabled="advertisingButton"
              >{{ advertising.app_advertising_name }}</van-button
            >
          </div>
          <div class="falseBtn" v-else-if="advertisingisIntegral == 1">
            已领完
          </div>
          <div
            class="falseBtn"
            v-else
            @click="maintain(advertising.vindicate_reason)"
          >
            维护中
          </div>
        </div>
        <!-- 看小说 -->
        <div
          class="item"
          v-if="
            book.advertising_name && userID != '1809228' && userID != '1873418'
          "
        >
          <div class="photo">
            <img :src="book.icon" />
          </div>
          <div class="text">
            <p>
              {{ book.advertising_name
              }}<img src="./../../assets/integral/hot.png" />
            </p>
            <p>阅读小说奖励0.5积分</p>
          </div>
          <div class="btn" v-if="bookisIntegral == 0 && book.is_vindicate == 1">
            <van-button @click="toBook(book.id)" :disabled="bookButton">{{
              book.app_advertising_name
            }}</van-button>
          </div>
          <div
            class="btn"
            v-else-if="bookisIntegral == 1"
            @click="toBook(book.id)"
          >
            已领完
          </div>
          <div class="falseBtn" v-else @click="maintain(book.vindicate_reason)">
            维护中
          </div>
        </div>
        <!-- 互动广告 -->
        <div
          class="item"
          v-if="
            interact.advertising_name &&
            userID != '1809228' &&
            userID != '1873418'
          "
        >
          <div class="photo">
            <img :src="interact.icon" />
          </div>
          <div class="text">
            <p>{{ interact.advertising_name }}</p>
            <p>参与互动广告赚积分</p>
          </div>
          <div
            class="btn"
            v-if="interactisIntegral == 0 && interact.is_vindicate == 1"
          >
            <van-button
              @click="toInteract(interact.url)"
              :disabled="interactButton"
              >{{ interact.app_advertising_name }}</van-button
            >
          </div>
          <div class="falseBtn" v-else-if="interactisIntegral == 1">已领完</div>
          <div
            class="falseBtn"
            v-else
            @click="maintain(interact.vindicate_reason)"
          >
            维护中
          </div>
        </div>
        <!-- ceshi互动广告 -->
        <div
          class="item"
          v-if="
            interact.advertising_name &&
            userID != '1809228' &&
            userID != '1873418'
          "
        >
          <div class="photo">
            <img src="./../../assets/integral/test.png" />
          </div>
          <div class="text">
            <p>免费领福利</p>
            <p>送红包，百分之百有奖哦</p>
          </div>
          <div class="btn">
            <van-button
              @click="
                toRechargeGame(
                  'ceshi',
                  'https://eg.cpoop.cn/redirect/index?appKey=3WqNNQA9ndAmp19EKqUDnrG8iNLTdaeksTeKgSL&adslotId=29246'
                )
              "
              :disabled="interactButton"
              >领红包</van-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 积分商城 -->
    <div class="module" v-if="goodsLList.length || goodsRList.length">
      <div class="title">
        <img src="../../assets/integral/ring.png" class="icon" />
        <div class="text">
          <span>积分商城</span>
          <!-- <span>玩转积分秒提现</span> -->
        </div>
        <span class="more" @click="toMore">查看更多</span>
        <!-- <van-icon name="arrow" class="right"/> -->
      </div>
      <div class="content goods">
        <div class="item-container">
          <div
            class="item"
            v-for="(item, index) of goodsLList"
            :key="'goods-l-' + index"
            @click="toGoods(item.id)"
          >
            <div class="photo">
              <img :src="item.thumb" alt />
            </div>
            <div class="content">
              <div class="tag" v-if="item.self_id || item.postage_free == 1">
                <!-- <img
                  v-if="item.self_id"
                  src="../../assets/integral/zy.png"
                  alt
                /> -->
                <img
                  v-if="item.postage_free == 1"
                  src="../../assets/integral/by.png"
                  alt
                />
              </div>
              <span>{{ item.name }}</span>
              <div>
                <span
                  class="price"
                  v-html="item.activity_min_price + '<span>积分</span>'"
                ></span>
                <span class="location">{{ item._location }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="item-container">
          <div
            class="item"
            v-for="(item, index) of goodsRList"
            :key="'goods-r-' + index"
            @click="toGoods(item.id)"
          >
            <div class="photo">
              <img :src="item.thumb" alt />
            </div>
            <div class="content">
              <div class="tag" v-if="item.self_id || item.postage_free == 1">
                <!-- <img
                  v-if="item.self_id"
                  src="../../assets/integral/zy.png"
                  alt
                /> -->
                <img
                  v-if="item.postage_free == 1"
                  src="../../assets/integral/by.png"
                  alt
                />
              </div>
              <span>{{ item.name }}</span>
              <div>
                <span
                  class="price"
                  v-html="item.activity_min_price + '<span>积分</span>'"
                ></span>
                <span class="location">{{
                  item.ship_city || item.ship_province
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import avatarDefault from "@/assets/common/avatar.png";

export default {
  name: "playCoin",
  data() {
    return {
      show: 0,
      gameSwiperOption: {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 13,
        slidesPerGroup: 1,
        watchSlidesProgress: true,
        on: {
          progress: function () {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);

              var slideProgress = this.slides[i].progress;
              var scale = 1 - Math.abs(slideProgress + 1) / 4;
              slide.transform("scale(" + scale + ")");
            }
          },
          click: () => {
            let swiper = this.$refs.mySwiper.swiper;
            let id = swiper.clickedSlide.dataset.id;
            this.toGame(id);
          },
        },
      },
      adShow: false,
      adSwiperOption: {
        loop: true,
        speed: 200,
        spaceBetween: 13,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
      },

      nickname: "",
      head_pic: "",
      adList: [],
      finish: 0,
      taskList: [],
      totalCredit: 0,
      todayCredit: 0,
      goodsLList: [],
      goodsRList: [],
      CreditsList: [],
      RechargeGameUrl: "",
      book: {},
      interact: {},
      advertising: {},
      bookisIntegral: 0,
      advertisingisIntegral: 0,
      interactisIntegral: 0,
      bookButton: false,
      interactButton: false,
      advertisingButton: false,
      rechargeData: {},
      userID: 0,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.getUserInfo();
    this.getAdList();
    this.getTaskList();
    this.getCoinInfo();
    this.getGoodsList();

    this.getCreditsGame();
    this.getRechargeGame();
    this.getAdvertisingData();
  },
  mounted() {
    // this.initGameSwiperEvent();
    this.getIsTheTntegralData();
  },
  computed: {
    taskStat() {
      return `${this.finish}/${this.taskList.length}`;
    },
  },
  methods: {
    // 游戏轮播点击事件
    // initGameSwiperEvent() {
    //   let gameSwiper = document.querySelectorAll(".more .swiper-slide");
    //   gameSwiper.forEach(_ => {
    //     _.addEventListener("click", () => {
    //       this.toGame(_.dataset.id, _.dataset.url);
    //     });
    //   });
    // },
    // 广告轮播点击事件
    initAdSwiperEvent() {
      let adSwiper = document.querySelectorAll(".ad .swiper-slide");
      adSwiper.forEach((_) => {
        _.addEventListener("click", () => {
          this.toAd(_.dataset.route);
        });
      });
    },
    // 帮助
    toHelp() {
      this.params(null, null, "toHelp");
    },
    // // 用户详情
    // toUser() {
    //     this.params(null, null, "toUser");
    // },
    // 广告
    toAd(param) {
      console.log(param)
      param && this.params(param, param, "toAd");
    },
    // 游戏
    // toGame(param) {
    //   this.params(param, param, "toGame");
    // },
    // 积分类游戏
    toGame(id) {
      // console.log("积分游戏" + id);
      this.$api
        .post("game/member/credits-game/code/generate", {
          game_id: id,
        })
        .then((res) => {
          // // console.log(res);
          this.$toast("加载中");
          this.params(res.url, res.url, "toGame");
        })
        .catch((res) => {
          this.$toast(res.message);
        });
    },
    // 充值类游戏
    toRechargeGame(id, url) {
      this.$toast("加载中");
      if (id == "ceshi") {
        this.params(url, url, "toRechargeGame");
      } else {
        this.$api
          .post("game/member/recharge-game/sign/url-encryption", {
            supplier_id: id,
          })
          .then((res) => {
            // console.log(res);
            // window.location.href = res.game_url;
            this.params(res.game_url, res.game_url, "toRechargeGame");
          });
      }
    },
    // 小说
    toBook(id, is_vindicate, vindicate_reason) {
      // 防重复点击
      this.bookButton = true;
      setTimeout(() => {
        this.bookButton = false;
      }, 2000);
      //具体的代码
      let param = JSON.stringify({ url: null, type: id ? id : -1 });
      // console.log(param);
      this.params(param, param, "toBook");
    },
    // 激励视频
    toAdvertising(id, is_vindicate, vindicate_reason) {
      // 防重复点击
      this.advertisingButton = true;
      setTimeout(() => {
        this.advertisingButton = false;
      }, 4000);

      let param = JSON.stringify({ url: null, type: id ? id : -1 });
      // console.log(param);
      this.params(param, param, "toAdvertising");
    },
    // 互动广告
    toInteract(params, id, is_vindicate, vindicate_reason) {
      // 防重复点击
      this.interactButton = true;
      setTimeout(() => {
        this.interactButton = false;
      }, 2000);

      let param = JSON.stringify({ url: params, type: id ? id : -1 });
      console.log(param);
      this.params(param, param, "toInteract");
    },
    // 维护中
    maintain(vindicate_reason) {
      this.$toast(vindicate_reason);
    },
    // 签到
    toSign() {
      this.$api.post("task/member/task/daily-sign").then((res) => {
        this.$toast("签到成功");
        this.getCoinInfo();
        this.getTaskList();
      });
    },
    // 做任务
    toTask(url, isSign) {
      if (isSign) {
        return this.toSign();
      }
      this.params(url, url, "toTask");
    },
    // 查看更多
    toMore() {
      this.params(null, null, "toMore");
    },
    // 查看商品
    toGoods(param) {
      this.params(param, param, "toGoods");
    },
    // 获取用户信息
    getUserInfo() {
      this.$api.get("member/member/user/detail").then((res) => {
        // console.log(res);
        this.userID = res.id;
        this.head_pic =
          res.infos.head_pic || require("../../assets/common/avatar.png");
      });
    },
    // 获取积分类游戏列表
    getCreditsGame() {
      this.$api
        .get("/game/member/credits-game/closed_beta/check")
        .then((req) => {
          if (req.closed_beta_permissions) {
            this.$api
              .post("/game/member/credits-game/game/list", {
                page: 1,
                size: 100,
              })
              .then((res) => {
                // console.log(res.list);
                res.list.forEach((item, index) => {
                  if (item.show == 1) {
                    this.CreditsList.push(item);
                  }
                });
              });
          }
        });
    },
    // 获取充值类游戏三方入口
    getRechargeGame() {
      this.$api.post("game/member/recharge-game/game/supplier").then((res) => {
        // console.log(res);
        this.rechargeData = res;
      });
    },
    // 获取广告
    getAdvertisingData() {
      this.$api.post("thirdad/member/advertising/list").then((res) => {
        // console.log(res);
        // 获取小说
        this.book = res.novel;
        // 获取激励视频
        this.advertising = res.incentive;
        // 获取互动广告
        // this.interact = res.interactive;
      });
    },
    // 获取当前用户是否可通过广告继续领取积分
    getIsTheTntegralData() {
      this.$api
        .post("thirdad/member/advertising/statistics/credit")
        .then((res) => {
          // console.log(res);
          // 获取小说
          this.bookisIntegral = res.novel.status;
          // 获取激励视频
          this.advertisingisIntegral = res.incentive.status;
          // 获取互动广告
          this.interactisIntegral = res.interactive.status;
        });
    },
    // 获取任务列表
    getTaskList() {
      this.$api.get("task/member/task/list").then((res) => {
        // console.log(res.list);
        // this.$toast(JSON.stringify(res.list));
        // res.list.forEach(_ => {
        //     if (_.rewarded) {
        //         this.finish += 1;
        //     }
        // });
        this.taskList = [...res.list];
      });
    },
    // 获取广告位
    getAdList() {
      this.$api
        .post("activity/index/ad/get-data", {
          label: "play_points_banner",
        })
        .then((res) => {
          // console.log(res);
          this.adList = res.adData;
          this.adShow = res.adData.length;
          this.$nextTick(() => this.initAdSwiperEvent());
        });
    },
    // 获取积分信息
    getCoinInfo() {
      this.$api
        .post("coin/member/appCredits/queryMine", {
          accountType: 1,
        })
        .then((res) => {
          // console.log(res);
          this.totalCredit = res.nowCredits || 0;
          this.todayCredit = res.todayCreditsIncrease || 0;
        });
    },
    // 获取商品列表
    getGoodsList() {
      this.$api
        .post("ongoods/index/goods/search", {
          is_point_goods: 1,
          order_by: "approve_time",
          sort: "desc",
          page: 1,
          pageSize: 4,
        })
        .then((res) => {
          // console.log(res.list);
          if (Object.prototype.toString.call(res.list) == "[object Array]") {
            res.list.forEach((_, i) => {
              _._location = _.ship_city || _.ship_province;
              if (_.ship_city == "市辖区") {
                _._location = _.ship_province;
              }
              if (i % 2 == 0) {
                this.goodsLList.push(_);
              } else {
                this.goodsRList.push(_);
              }
            });
          }
        });
    },
    defaultPro() {
      var img = event.srcElement;
      img.src = avatarDefault;
      img.onerror = null; //防止闪图
    },
  },
  beforeCreate: function () {
    document.getElementsByTagName("body")[0].className = "bg-gray";
  },
  beforeDestroy: function () {
    document.body.removeAttribute("class", "bg-gray");
  },
};
</script>

<style>
.bg-gray {
  background-color: #f2f2f2;
}
</style>

<style lang="less" scoped>
.main {
  position: relative;
  font-size: 15px;
  color: #333333;
  padding-top: var(--status-height);

  background-image: url(../../assets/integral/top.png);
  background-repeat: no-repeat;
  background-size: 100% calc(106px + var(--status-height));

  // background-color: RGBA(242, 242, 242, 1);
  .img {
    width: 100%;
  }

  .btn {
    width: 80px;
    height: 40px;
    background: url(../../assets/integral/btn.png);
    background-size: 100%;
    background-position-y: 2px;
    color: #ea5900;
    display: flex;
    justify-content: center;
    align-items: center;

    &.used {
      background: url(../../assets/integral/btn-used.png);
      background-size: 100%;
      background-position-y: 2px;
      color: #b8b8b8;
      pointer-events: none;
    }
  }

  .top {
    line-height: 50px;
    margin: 0 12px;
    text-align: right;
  }

  .user {
    height: 97px;
    top: 68px;
    margin: 0 12px 10px;
    border-radius: 15px;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 19px 14px;

    .img {
      width: 50px;
      height: 50px;
      margin-right: 20px;
      border-radius: 100%;
    }

    .content {
      flex: 1;
      display: flex;
      align-items: center;

      .item {
        flex: 1;
        display: flex;
        flex-direction: column;
        font-size: 13px;

        .title {
          color: #999999;
          display: flex;
          align-items: center;

          .arrow {
            width: 6px;
            height: 7px;
            margin-left: 6px;
          }
        }

        .num {
          margin-top: 9px;
        }
      }
    }
  }

  .ad {
    margin: 0 12px;
    padding-top: 10px;

    .img {
      border-radius: 10px;
      // height: 85px;
    }
  }

  .module {
    padding: 0 12px;

    .title {
      display: flex;
      height: 40px;
      align-items: center;
      padding: 0;

      .icon {
        width: 8px;
        margin-right: 7px;
      }

      .text {
        flex: 1;
        display: flex;
        align-items: flex-end;

        span:first-of-type {
          font-weight: bold;
          font-size: 16px;
        }

        span:nth-of-type(2) {
          font-size: 10px;
          margin-left: 10px;
        }
      }

      .more {
        color: #999;
        font-size: 12px;
      }

      .btn {
        margin-right: 10px;
      }
    }

    .content {
      padding: 10px 0;
    }
  }

  .game {
    .two {
      display: flex;
      justify-content: space-between;

      div {
        flex: 1;

        &:last-child {
          margin-left: 10px;
        }
      }
    }

    .three {
      display: flex;
      justify-content: space-between;
      align-items: center;

      div {
        flex: 1;
        margin-left: 13px;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    .more {
      touch-action: none;
    }
  }

  .task {
    .item {
      height: 80px;
      background: #fff;
      border-radius: 10px;
      margin-top: 7px;
      display: flex;
      align-items: center;
      padding: 0 10px;

      &:first-child {
        margin-top: 0;
      }

      .photo {
        width: 70px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          max-width: 45px;
          max-height: 50px;
        }
      }

      .text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 23px 0;

        p {
          margin: 0;
          img {
            width: 28px;
            height: 16px;
            margin-left: 5px;
          }
          .gameimg {
            width: 21px;
            height: 22px;
          }

          &:first-child {
            font-weight: 500;
          }

          &:last-child {
            font-size: 12px;
            color: #999;
          }
        }
      }

      .btn {
        font-size: 13px;
        .van-button {
          color: #ea5900;
        }
        .van-button--disabled {
          opacity: 1;
        }
        button {
          border: none;
          background-color: rgba(255, 255, 255, 0);
        }
      }
      .falseBtn {
        font-size: 14px;
        width: 80px;
        height: 40px;
        background: url(../../assets/integral/btn-used.png);
        background-size: 100%;
        background-position-y: 2px;
        color: #b8b8b8;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .goods {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 0 !important;
    justify-content: space-between;

    .item-container {
      flex: 0 1 calc(50% - 3.5px);
      overflow: hidden;
      margin-bottom: 12px;

      .item {
        flex: 0 1 100%;
        overflow: hidden;
        background: #fff;
        position: relative;
        border-radius: 10px;
        margin-bottom: 8px;

        .photo {
          position: relative;

          & > img {
            width: 100%;
            // height: 166px;
          }

          .flag {
            width: 12px;
            height: 12px;
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }

        .content {
          padding: 10px;
          display: flex;
          flex-direction: column;

          .tag {
            margin-bottom: 10px;

            img {
              width: 33px;
              height: 14px;
              margin-left: 5px;

              &:first-child {
                margin-left: 0;
              }
            }
          }

          & > span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 13px;
          }

          & > div {
            margin-top: 4px;
            display: flex;
            align-items: flex-end;

            .price {
              color: #e6212f;
              flex: 1;
              font-size: 16px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-right: 5px;

              /deep/ span {
                font-size: 10px;
              }
            }

            .location {
              color: #999;
              font-size: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
